export default __webpack_public_path__ + "static/media/banner_5.12.79e687d0.jpg";